 

import { Row, Col } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import Header from "./header";
import Footer from "./footer";
import { useBranding } from "../../../contexts/branding";
import { OTPBanner } from "../../login/otp/baner";
import { OptResponse } from "../../login/otp/types";
import HabitnuCarousel from "./image-carousel";
import i18n from "../../../utils/i18n";

interface Props {
    showFooter?: boolean;
    children: React.ReactNode;
    showOtpBanner?: boolean;
    otpDeliveryMode?: OptResponse;
    hideRegistartionLink?: boolean;
}

export function AppLayout({
    showFooter = true,
    children,
    showOtpBanner = false,
    otpDeliveryMode,
    hideRegistartionLink,
}: Props) {
    const { backgroundUrl, privacyUrl, label, termsUrl } = useBranding();
    const { t } = useTranslation();
    return (
        <Row className="bg-white-transparent h-screen margin-left-0 margin-right-0">
            <Col
                sm={12}
                md={12}
                lg={6}
                className="bg-white-transparent login-form login-left-container md-10"
            >
                <Row>
                    <Col sm={12}>
                        <div
                            className={
                                label === "HabitNu" ? "p-4 rounded" : "rounded"
                            }
                        >
                            <Header />
                        </div>
                    </Col>
                </Row>
                <div className="login-control-container">
                    <Row className="padding-0-30">
                        <Col sm={12}>
                            {showOtpBanner && (
                                <OTPBanner deliveryMode={otpDeliveryMode} />
                            )}
                        </Col>
                    </Row>
                    <Row className="login-form-container">
                        <Col sm={12} className="max-width-650 ml-10">
                            <Row>
                                <Col sm={12}>
                                    {children}
                                    {showFooter && (
                                        <Footer
                                            hideRegistartionLink={
                                                hideRegistartionLink
                                            }
                                        />
                                    )}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <Row>
                    <Col>
                        <p className="text-center">
                            <Trans i18nKey="policy_and_terms">
                                <a
                                    href={
                                        i18n.language === "en"
                                            ? privacyUrl
                                            : `${privacyUrl}-es`
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={
                                        label !== "HabitNu" ? "ada-link" : ""
                                    }
                                >
                                    {t("Privacy Policy")}
                                </a>{" "}
                                <a
                                    href={
                                        i18n.language === "en"
                                            ? termsUrl
                                            : `${termsUrl}-es`
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={
                                        label !== "HabitNu" ? "ada-link" : ""
                                    }
                                >
                                    {t("Terms of Use")}
                                </a>
                            </Trans>
                        </p>
                    </Col>
                </Row>
            </Col>
            <Col
                sm={12}
                md={12}
                lg={6}
                className="login-background app-background"
            >
                {label === "HabitNu" ? (
                    <HabitnuCarousel />
                ) : (
                    <div
                        style={{
                            backgroundSize: "cover",
                            backgroundAttachment: "local",
                            backgroundImage: `url(${backgroundUrl})`,
                            backgroundColor: "#cccccc",
                            minHeight: "100%",
                            /* Set up proportionate scaling */
                            minWidth: "100%",
                            width: "auto",
                            height: "auto",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            position: "relative",
                        }}
                    />
                )}
            </Col>
        </Row>
    );
}
